import React from "react";
import ArrowCircleRight from "../pages/arrow-circle-right";
import ContactUs from "../pages/contact-us";
import Card from "../pages/homePage/card";

const CommunicationToolsPage = ({
  heroTitle = "Deliver Text Messages Effortlessly",
  heroDescription = "Reach thousands of customers instantly with our reliable Bulk SMS service...",
  heroImage = "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330116/sleenshort/bulk-sms/z9zsmir0mvmrqjsqtvgg.png",

  whyChooseTitle = "Why Choose SleengShort messaging service",
  features = [],

  useCaseTitle = "Use Case",
  useCases = [],
}) => {
  return (
    <main className="max-w-screen-xl mx-auto px-4 py-10">
      {/* hero */}
      <section className="flex items-center md:flex-row flex-col-reverse gap-8 md:gap-16 px-10 md:px-0">
        <div className="space-y-6 md:text-left text-center">
          <h3 className="text-xl md:text-5xl font-medium text-[#1E1E1E]">
            {heroTitle.split("\n").map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </h3>
          <p className="font-light text-2xs md:text-sm">{heroDescription}</p>
        </div>
        <img src={heroImage} className="w-[530px]" alt={`${heroTitle} hero`} />
      </section>

      {/* why choose */}
      <section className="mt-16 md:mt-32 px-6 md:px-0">
        <h3 className="font-semibold text-xl md:text-3xl text-primary text-center">
          {whyChooseTitle}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-6 md:gap-y-12 mt-8 px-6 md:px-0">
          {features.map((item, i) => (
            <div key={i} className="flex items-center gap-3">
              <img
                src={item.icon}
                alt={item.title}
                className="w-10 h-10 md:w-fit md:h-fit"
              />
              <div>
                <p className="text-primary font-medium mb-1 text-2xs md:text-base">
                  {item.title}
                </p>
                <p className="font-light text-2xs md:text-sm">{item.descr}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* use case */}
      <section className="my-36 px-6 md:px-0">
        <h3 className="mb-6 font-semibold text-xl md:text-3xl text-primary">
          {useCaseTitle}
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {useCases.map((item, i) => (
            <Card
              key={i}
              img={item.img}
              title={item.title}
              description={item.descr}
            />
          ))}

          <div className="bg-[#DCE7FE] rounded-xl w-full p-2 md:p-10 space-y-2 md:space-y-4">
            <p className="text-primary text-sm md:text-3xl font-semibold">
              Ready to Transform Your Business Communication?
            </p>
            <p className="font-light md:pb-10 text-xs md:text-base">
              Sign up now and experience the power of instant messaging.
            </p>
            <div className="sm:block hidden">
              <ArrowCircleRight />
            </div>
          </div>
        </div>
      </section>

      <ContactUs />
    </main>
  );
};

export default CommunicationToolsPage;
